// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1458":"64cae7bc","6603":"f6d340cf","7823":"26106fd9","8672":"64cae7bc"}[chunkId] + ".chunk.css";
};